/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import {
  BFF_BASE_URL,
  SERVER_API_URL,
  USER_SERVICE_SERVER_URL_LPL,
  USER_SERVICE_SERVER_URL_SECURE
} from 'app/app.constants';
import { AppStore } from 'app/redux-export';
import { UserToken } from 'app/modules/chart/interface/interfaces';
import { WindowsService } from '@smarsh-cyber/shared/services';
import { AppFacadeService } from '@smarsh-cyber/app-state';
import { HEADER } from '@smarsh-cyber/shared/constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private appFacade: AppFacadeService,
    private windowsService: WindowsService,
    private appStore: AppStore
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !request ||
      !request.url ||
      (/^http/.test(request.url) &&
        !(SERVER_API_URL && request.url.startsWith(SERVER_API_URL)) &&
        !(
          USER_SERVICE_SERVER_URL_LPL &&
          request.url.startsWith(USER_SERVICE_SERVER_URL_LPL)
        ) &&
        !(BFF_BASE_URL && request.url.startsWith(BFF_BASE_URL)) &&
        !(BFF_BASE_URL && request.url.startsWith(BFF_BASE_URL)) &&
        !(
          USER_SERVICE_SERVER_URL_SECURE &&
          request.url.startsWith(USER_SERVICE_SERVER_URL_SECURE)
        ))
    ) {
      if (
        ['/verifyOtp', '/sendOtp', '/users/login', '/auth/resetPassword'].some(
          (path) => request.url.includes(path)
        )
      ) {
        request = request.clone({
          setHeaders: {
            'X-SubDomain': this.appFacade.$userToken().portalName
          }
        });
      } else {
        request = request.clone({
          withCredentials: true
        });
      }
      return next.handle(request);
    }
    let token =
      this.windowsService.getFromLocalStorage('authenticationToken') ||
      this.windowsService.getFromSessionStorage('authenticationToken');
    if (!token) {
      const userToken: UserToken = this.appStore.getState().userTokenReducer;
      token = userToken.authToken;
    }
    if (token && !(BFF_BASE_URL && request.url.startsWith(BFF_BASE_URL))) {
      request = request.clone({
        setHeaders: {
          [HEADER.AUTHORIZATION]: 'Bearer ' + token
        }
      });
    }
    return next.handle(request);
  }
}
